import { useState } from "react";
import Footer from "../../components/feature/Footer";
import HeroEditor from "./components/HeroEditor";
import ServicesEditor from "./components/ServicesEditor";
import PortfolioEditor from "./components/PortfolioEditor";
import TestimonialsEditor from "./components/TestimonialsEditor";
import ContactEditor from "./components/ContactEditor";
import LawFirmOfferEditor from "./components/OfferEditor";
import ContactList from "./ContactList";
import MediaManager from "./media/MediaManager";

export default function DashboardPage() {
  const [activeTab, setActiveTab] = useState("hero");
  const [showContactList, setShowContactList] = useState(false);
  const [showMediaManager, setShowMediaManager] = useState(false); // ✅

  const tabs = [
    { id: "hero", label: "Hero Section", icon: "ri-home-line" },
    { id: "services", label: "Services", icon: "ri-service-line" },
    { id: "portfolio", label: "Portfolio", icon: "ri-folder-line" },
    { id: "testimonials", label: "Testimonials", icon: "ri-chat-quote-line" },
    { id: "contact", label: "Contact Info", icon: "ri-contacts-line" },
    { id: "law-firm-offer", label: "Law Firm Offer", icon: "ri-scales-3-line" },
  ];

  const renderActiveEditor = () => {
    switch (activeTab) {
      case "hero":
        return <HeroEditor />;
      case "services":
        return <ServicesEditor />;
      case "portfolio":
        return <PortfolioEditor />;
      case "testimonials":
        return <TestimonialsEditor />;
      case "contact":
        return <ContactEditor />;
      case "law-firm-offer":
        return <LawFirmOfferEditor />;
      default:
        return <HeroEditor />;
    }
  };

  const showDefaultTabs = !showContactList && !showMediaManager;

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="container mx-auto px-6 py-12">
        <div className="mb-12">
          {/* Header */}
          <div className="flex flex-wrap items-center justify-between mb-8 gap-4">
            <div>
              <h1 className="text-4xl font-bold text-slate-800 mb-2">
                Content Dashboard
              </h1>
              <p className="text-lg text-slate-600">
                Manage and update your landing page content
              </p>
            </div>

            {/* ✅ Action buttons */}
            <div className="flex gap-3">
              <button
                onClick={() => {
                  setShowContactList((prev) => !prev);
                  setShowMediaManager(false);
                }}
                className="flex items-center gap-2 px-5 py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg font-semibold shadow-sm transition-all"
              >
                <i className="ri-mail-line text-lg"></i>
                {showContactList ? "Hide Contacts" : "View Contacts"}
              </button>

              <button
                onClick={() => {
                  setShowMediaManager((prev) => !prev);
                  setShowContactList(false);
                }}
                className="flex items-center gap-2 px-5 py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg font-semibold shadow-sm transition-all"
              >
                <i className="ri-gallery-line text-lg"></i>
                {showMediaManager ? "Hide Media" : "Manage Media"}
              </button>
            </div>
          </div>

          {/* ✅ Conditional Rendering */}
          {showContactList ? (
            <div className="bg-white rounded-2xl shadow-lg border border-slate-200 overflow-hidden">
              <div className="p-8">
                <ContactList />
              </div>
            </div>
          ) : showMediaManager ? (
            <div className="bg-white rounded-2xl shadow-lg border border-slate-200 overflow-hidden">
              <div className="p-8">
                <MediaManager />
              </div>
            </div>
          ) : (
            <div className="bg-white rounded-2xl shadow-lg border border-slate-200 overflow-hidden">
              <div className="border-b border-slate-200">
                <nav className="flex overflow-x-auto">
                  {tabs.map((tab) => (
                    <button
                      key={tab.id}
                      onClick={() => setActiveTab(tab.id)}
                      className={`flex items-center px-8 py-6 text-sm font-semibold transition-all duration-300 border-b-2 whitespace-nowrap ${
                        activeTab === tab.id
                          ? "text-emerald-600 border-emerald-600 bg-emerald-50/50"
                          : "text-slate-600 border-transparent hover:text-slate-800 hover:bg-slate-50"
                      }`}
                    >
                      <i className={`${tab.icon} mr-3 text-lg`}></i>
                      {tab.label}
                    </button>
                  ))}
                </nav>
              </div>

              <div className="p-8">{renderActiveEditor()}</div>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
}
